import HelperDate from '../../helpers/HelperDate';
import moment from 'moment';

interface IProp {
    proposal: any;
    statusActual: any;
}
const ActionViewSubStatus = ({ proposal, statusActual }: IProp) => {
    const SalesForceContractRejectEnumDescription: Record<number, string> = {
        1: "Inviabilidade Financeira",
        2: "Inviabilidade Técnica",
        3: "Sem área para instalação",
        4: "Parado por 30 dias",
        5: "Sem contato com o cliente ou consultor",
        6: "Cliente fechou com outra empresa",
        7: "Consultor/Cliente recusou a proposta",
        8: "Cliente desistiu",
        9: "Cliente retomará a negociação em outra data",
        10: "Cliente prosseguiu com outra proposta, duplicata",
        11: "Outro",
    };
    function getSalesForceContractRejectDescription(value: number): string {
        return SalesForceContractRejectEnumDescription[value] ?? "Desconhecido";
    }
    if (proposal.idProposalStatus === statusActual.idProposalStatus) {
        return (
            <>
                <p className="mb-0">{proposal.proposalSubStatus?.name ?? ""}</p>
                {
                    ((proposal?.technicalVisitDate ?? null) !== null && statusActual.proposalStatus.name === "Apresentação Comercial") &&
                    <p>Data agendado: {HelperDate.convertFormatDate(proposal?.technicalVisitDate, moment.ISO_8601, "DD/MM/YYYY HH:mm")}</p>
                }
                {
                    (((proposal?.lossReason ?? 0) > 0) && statusActual.proposalStatus.name === "Análise de Crédito") &&
                    <p>Motivo: {getSalesForceContractRejectDescription(proposal?.lossReason)}</p>
                }
                {
                    ((proposal?.descriptionReasonLoss ?? null) !== null && statusActual.proposalStatus.name === "Análise de Crédito") &&
                    <p>Descrição: {proposal?.descriptionReasonLoss}</p>
                }
            </>
        )
    } else {
        return null
    }
};

export default ActionViewSubStatus;